
import { Component, Prop, Mixins, Watch } from "vue-property-decorator";
import FormValidator from "@/mixins/FormValidator";
import DateHelpers from "@/mixins/DateHelpers";
import LabelHelpers from "@/mixins/LabelHelpers";
// import comunas from "@/helpers/comunas.json";
import countries from "@/helpers/countries.json";

interface guestData {
  name: string;
  father_last_name: string;
  mother_last_name: string;
  nationality: any;
  document_type: string;
  document_id: string | null;
  motive: any | null;
  district: any;
  street: string;
  street_number: string;
  hint: string;
  email: string;
  phone: string;
  date_birth: string | null;
  genre: string | number;
}

interface Tipos {
  value: number | any;
  label: string;
}

@Component
export default class GuestFormDT extends Mixins(
  FormValidator,
  DateHelpers,
  LabelHelpers
) {
  @Prop({ default: false }) readonly date_request!: boolean;
  options_document: object[] = [
    { label: "RUT", value: "1" },
    { label: "Pasaporte", value: "2" },
  ];
  options_motive: object[] = [];

  comunas: Array<any> = [];
  options_district: any = [];
  options_nationality: any = countries;
  options_street: any = [];
  streets: any[] = [];
  street_loading = false;
  street_search_empty = false;
  confirm_email = false;
  chilean = true;
  comuna_municipalidad: any = {
    id: 0,
    id_region: 0,
    nombre: "",
  };

  protected formData: guestData = {
    name: "",
    father_last_name: "",
    mother_last_name: "",
    nationality: {
      value: 47,
      code: "CL",
      country_en: "Chile",
      country_es: "Chile",
      label: "Chilena",
    },
    motive: null,
    document_type: "1",
    document_id: "",
    district: "",
    street: "Sin información",
    street_number: "0",
    hint: "",
    email: "",
    phone: "",
    date_birth: "",
    genre: "",
  };

  options_genre = [
    { label: "Femenino", value: "1" },
    { label: "Masculino", value: "2" },
    { label: "Otro", value: "3" },
    { label: "Prefiero no decirlo", value: "4" },
  ];

  private aMotivo: Array<any> = [];
  private motivoData: Tipos | null = null;

  private fechaHoy: any = new Date();
  private formattedFecha: string | null = "";

  // private motivoData: Tipos = {
  //   value: null,
  //   label: "Selecciona una opción",
  // };

  my_locale = {
    days: "Domingo_Lunes_Martes_Miércoles_Jueves_Viernes_Sábado".split("_"),
    daysShort: "Dom_Lun_Mar_Mié_Jue_Vie_Sáb".split("_"),
    months: "Enero_Febrero_Marzo_Abril_Mayo_Junio_Julio_Agosto_Septiembre_Octubre_Noviembre_Diciembre".split(
      "_"
    ),
    monthsShort: "Ene_Feb_Mar_Abr_May_Jun_Jul_Ago_Sep_Oct_Nov_Dic".split("_"),
    firstDayOfWeek: 7,
  };

  @Watch("motivoData")
  private optionMotivo(newValue: any) {
    this.formData.motive = newValue.value;
  }

  // @Watch("formData.document_type")
  // private changeDocumentType(newValue: any) {
  //   if (newValue == 2) {
  //     this.formData.document_id = "";
  //   } else {
  //     this.formData.document_id = "";
  //   }
  // }

  @Watch("formData.document_type")
  private changeDocumentType(newValue: any, oldValue: any) {
    if (oldValue && oldValue !== newValue && !this.formData.document_id) {
      this.formData.document_id = "";
    }
  }

  @Watch("formData.phone")
  private watchPhone(newValue: any) {
    // 1. Validar que newValue no sea null o undefined
    if (!newValue) return;

    // 2. Convertir a String y luego aplicar los reemplazos
    let formated = String(newValue);

    formated = formated.replace(/\s/g, ""); // Elimina todos los espacios
    formated = formated.replace(/\./g, "");
    formated = formated.replace(/-/g, "");
    formated = formated.replace(/\+/g, "");
    formated = formated.replace(/,/g, "");

    // Solo actualizar si el valor cambió para evitar bucles infinitos
    if (this.formData.phone !== formated) {
      this.formData.phone = formated;
    }
  }

  private highlightMotive() {
    window.scrollTo(0, 0);
    //(this.$refs.guestForm as any).validate();
  }

  private clearStreet(): void {
    if (this.formData.district.label == this.comuna_municipalidad.nombre) {
      this.formData.street = "";
    }
  }

  private limitSince(date: any) {
    return Date.parse(date as any) <= Date.parse(this.fechaHoy as any);
  }

  private loadStoredData(): void {
    if (this.isUserLogged) {
      this.formData.name = this.$store.state.user.name;
      this.formData.father_last_name = this.$store.state.user.father_last_name;
      this.formData.mother_last_name = this.$store.state.user.mother_last_name;
      this.formData.nationality = countries.find(
        (country) => country.value === this.$store.state.user.country
      );
      this.formData.document_type = this.$store.state.user.document_type.toString();
      this.$nextTick(() => {
        this.formData.document_id = this.$store.state.user.rut;
      });
      this.formData.street = this.$store.state.user.adress.street;
      this.formData.street_number = this.$store.state.user.adress.number;
      this.formData.hint = this.$store.state.user.adress.hint;
      this.formData.email = this.$store.state.user.email;
      this.formData.phone = this.$store.state.user.phone;
      if (this.$store.state.user.date_birth) {
        this.formattedFecha = this.correctDate(
          this.$store.state.user.date_birth
        );
      }
      this.formData.genre = this.$store.state.user.genre
        ? this.$store.state.user.genre.toString()
        : null;
      if (this.$store.state.ticket.motive !== "") {
        for (let i = 0; i < this.aMotivo.length; i++) {
          if (this.aMotivo[i].value == this.$store.state.ticket.motive) {
            this.motivoData = {
              value: this.aMotivo[i].value,
              label: this.aMotivo[i].label,
            };
          }
        }
      }
    } else if (this.$store.state.ticket.guest) {
      this.formData.name = this.$store.state.ticket.guest_name;
      this.formData.father_last_name = this.$store.state.ticket.guest_father_name;
      this.formData.mother_last_name = this.$store.state.ticket.guest_mother_name;
      this.formData.nationality = countries.find(
        (country) => country.value === this.$store.state.ticket.guest_country
      );

      if (this.$store.state.ticket.guest_adress_district) {
        this.formData.district = this.comunas.find((c: any) => {
          const storeDistrict = this.$store.state.ticket.guest_adress_district
            .trim()
            .toLowerCase();
          const comunaLabel = c.label.trim().toLowerCase();
          return comunaLabel === storeDistrict;
        });
      }

      // Usar $nextTick para evitar que el watch interfiera
      this.$nextTick(() => {
        // Cargar document_id primero
        this.formData.document_id = this.$store.state.ticket.guest_id;

        // Luego cargar document_type en el siguiente ciclo
        this.$nextTick(() => {
           this.formData.document_type = String(this.$store.state.ticket.guest_document_type || "");
        });
      });
      this.formData.street = this.$store.state.ticket.guest_adress_street;
      this.formData.street_number = this.$store.state.ticket.guest_adress_number;
      this.formData.hint = this.$store.state.ticket.guest_adress_hint;
      this.formData.email = this.$store.state.ticket.guest_email;
      this.formData.phone = this.$store.state.ticket.guest_phone;

      if (this.$store.state.ticket.guest_date_birth != null) {
        this.formattedFecha = this.$store.state.ticket.guest_date_birth;
      }
      // this.formData.genre = this.$store.state.ticket.guest_genre.toString();
      this.formData.genre = this.$store.state.ticket.guest_genre
        ? this.$store.state.ticket.guest_genre.toString()
        : null;
      if (this.$store.state.ticket.motive !== "") {
        for (let i = 0; i < this.aMotivo.length; i++) {
          if (this.aMotivo[i].value == this.$store.state.ticket.motive) {
            this.motivoData = {
              value: this.aMotivo[i].value,
              label: this.aMotivo[i].label,
            };
          }
        }
      }
    }
  }

  private confirmDialog(): void {
    this.confirm_email = true;
  }

  waitForRecaptcha = (callback: any) => {
    const interval = setInterval(() => {
      if ((window as any).grecaptcha && (window as any).grecaptcha.enterprise) {
        clearInterval(interval);
        callback();
      }
    }, 300);
  };
  
  captchaResponse = "";
  onSubmit = () => {
    this.$q.loading.show();
    this.waitForRecaptcha(() => {
      (window as any).grecaptcha.enterprise.ready(() => {
        (window as any).grecaptcha.enterprise
          .execute(process.env.VUE_APP_KEY_CAPTCHA, {
            action: "IDENTIFY_USER",
          })
          .then((token:any) => {

            if (!token) {
              return;
            }

            this.identifyAttemp(token); // 🔥 pásalo directo
          });
      });
    });
  };

  private identifyAttemp(captcha: string): void {
    if (this.formData.motive == "" && this.date_request != true) {
      this.$q.notify({
        message: "Debe seleccionar un Motivo de contacto",
        color: "principal",
        position: "top",
        timeout: 5000,
      });
    } else {
      let ticket_data: any = {};
      ticket_data.motive = this.formData.motive;
      ticket_data.step = 3;
      if (!this.$store.state.logged) {
        this.$axios
          .post("personas/identificar", {
            nombre: this.formData.name,
            apellido_paterno: this.formData.father_last_name,
            apellido_materno: this.formData.mother_last_name,
            email: this.formData.email,
            telefono:
              Number(this.formData.phone) != 0
                ? Number(this.formData.phone)
                : null,
            tipo_documento: Number(this.formData.document_type),
            rut: this.formData.document_id,
            id_pais: this.formData.nationality.value,
            fecha_nacimiento: this.formattedFecha,
            genero: Number(this.formData.genre),
            //borrar una vez que se arregle el endpoint
            // kkkk
            tipo: 1,
            direccion: {
              id_comuna: this.formData.district.value,
              calle: this.formData.street,
              numero: this.formData.street_number,
              aclaratoria: this.formData.hint,
            }
            // solicitud: this.date_request
          },
          {
            headers: {
              Captcha: captcha
            }
          })
          .then((response) => {
            this.$q.loading.hide();
            let payload = {
              ticket: ticket_data,
              guest: response.data,
            };
            this.$store.dispatch("submitRequestStepTwo", payload);
          })
          .catch((error) => {
            this.$q.loading.hide();
            switch (error.response.data.error.message) {
              case "duplicate_rut":
                this.$q.notify({
                  message: "Rut ya registrado",
                  color: "principal",
                  position: "top",
                  timeout: 5000,
                });
                break;
              case "duplicate_email_error":
                this.$q.notify({
                  message: "El correo ya se encuentra registrado",
                  color: "principal",
                  position: "top",
                  timeout: 5000,
                });
                break;
              case "duplicate_email":
                this.$q.notify({
                  message: "El correo ya se encuentra registrado",
                  color: "principal",
                  position: "top",
                  timeout: 5000,
                });
                break;
              case "auth/email-already-exists":
                this.$q.notify({
                  message: "El correo ya se encuentra registrado",
                  color: "principal",
                  position: "top",
                  timeout: 5000,
                });
                break;
              case "invalid_user":
                this.$q.notify({
                  message: "El rut se encuentra registrado como usuario, favor de iniciar sesión para continuar.",
                  color: "principal",
                  position: "top",
                  timeout: 5000,
                });
                break;
              default:
                this.$q.notify({
                  message: "Ha ocurrido un error",
                  color: "principal",
                  position: "top",
                  timeout: 5000,
                });
                break;
            }
          });
      } else {
        let payload = {
          ticket: ticket_data,
        };
        this.$axios
          .post("personas/identificar", {
            nombre: this.formData.name,
            apellido_paterno: this.formData.father_last_name,
            apellido_materno: this.formData.mother_last_name,
            email: this.formData.email,
            telefono:
              Number(this.formData.phone) != 0
                ? Number(this.formData.phone)
                : null,
            tipo_documento: Number(this.formData.document_type),
            rut: this.formData.document_id,
            id_pais: this.formData.nationality.value,
            fecha_nacimiento: this.formattedFecha,
            genero: Number(this.formData.genre),
            //borrar una vez que se arregle el endpoint
            // kkkk
            tipo: 1,
            direccion: {
              id_comuna: this.formData.district.value,
              calle: this.formData.street,
              numero: this.formData.street_number,
              aclaratoria: this.formData.hint,
            },
            // solicitud: this.date_request
          }, {
            headers: {
              ...(this.$store.state.user.auth_token && {
                Authorization: "Bearer " + this.$store.state.user.auth_token
              }),
            }
          })
          .then((response) => {
            this.$q.loading.hide();
            this.$store.dispatch("updateUser", response.data);
            this.$store.dispatch("updateAddress", response.data.direccion);
          })
          .catch((error) => {
            this.$q.loading.hide();
            switch (error.response.data.error.message) {
              case "duplicate_rut":
                this.$q.notify({
                  message: "Rut ya registrado",
                  color: "principal",
                  position: "top",
                  timeout: 5000,
                });
                break;
              case "duplicate_email_error":
                this.$q.notify({
                  message: "El correo ya se encuentra registrado",
                  color: "principal",
                  position: "top",
                  timeout: 5000,
                });
                break;
              case "duplicate_email":
                this.$q.notify({
                  message: "El correo ya se encuentra registrado",
                  color: "principal",
                  position: "top",
                  timeout: 5000,
                });
                break;
              case "auth/email-already-exists":
                this.$q.notify({
                  message: "El correo ya se encuentra registrado",
                  color: "principal",
                  position: "top",
                  timeout: 5000,
                });
                break;
              default:
                this.$q.notify({
                  message: "Ha ocurrido un error",
                  color: "principal",
                  position: "top",
                  timeout: 5000,
                });
                break;
            }
          });

        this.$store.dispatch("submitRequestStepTwo", payload);
      }
    }
  }

  private get isUserLogged(): boolean {
    return this.$store.state.logged;
  }

  private checkIfChilean() {
    if (this.formData.nationality.value === 47) {
      this.chilean = true;
      this.formData.document_type = "1";
    } else {
      this.chilean = false;
    }
  }

  private async filterStreet(val: string, update: any, abort: any) {
    if (val == null) {
      return;
    }
    if (val === "") {
      update(() => {
        this.options_street = this.streets;
      });
      return;
    }
    update(() => {
      const value = val.toLowerCase();
      this.options_street = (this.streets as any).filter((street: any) => {
        return street.nombre.toLowerCase().indexOf(value) > -1;
      });
    });
  }

  private filterDistrict(val: string, update: any) {
    if (val === "") {
      update(() => {
        this.options_district = this.comunas;
      });
      return;
    }

    update(() => {
      const value = val.toLowerCase();
      this.options_district = (this.comunas as any).filter((comuna: any) => {
        return comuna.label.toLowerCase().indexOf(value) > -1;
      });
      if (this.formData.district) {
        this.options_district.unshift(this.formData.district);
      }
    });
  }

  private abortFilterFn() {
    this.options_district = this.comunas;
  }

  private filterNationality(val: string, update: any) {
    if (val === "") {
      update(() => {
        this.options_nationality = countries;
      });
      return;
    }

    update(() => {
      const value = val.toLowerCase();
      this.options_nationality = (countries as any).filter((country: any) => {
        let filtered = country.label.toLowerCase().indexOf(value) > -1;
        return filtered;
      });
      if (this.formData.nationality) {
        this.options_nationality.unshift(this.formData.nationality);
      }
    });
  }

  private streetDistrictData() {
    this.$axios
      .get("calles", {
        params: {
          filter: {
            where: { estado: 1 },
            fields: ["id", "id_comuna", "nombre", "estado"],
            order: "nombre ASC",
          },
        },
      })
      .then((response) => {
        this.streets = response.data;
      })
      .catch((error) => {
        this.$q.notify({
          message: "Ha ocurrido un error",
          color: "principal",
          position: "top",
          timeout: 5000,
        });
      });

    this.$axios
      .get("comunas/default")
      .then((response) => {
        this.comuna_municipalidad = response.data;
      })
      .catch((error) => {
        this.$q.notify({
          message: "Ha ocurrido un error",
          color: "principal",
          position: "top",
          timeout: 5000,
        });
      });
  }

  private getMotivo() {
    this.$axios
      .post("servicio-motivos/frontoffice", {
        id_servicio: Number(this.$store.state.ticket.service.id),
        nombre_categoria: this.$store.state.ticket.service.category,
      })
      .then((response) => {
        this.aMotivo = response.data;
        this.motivoData = response.data[0];
        this.aMotivoFunction();
        this.loadStoredData();
      })
      .catch((error) => {        
        this.$q.notify({
          message: this.$t("notification.problem") as string,
          color: "principal",
          position: "top",
          timeout: 5000,
        });
      });
  }

  private getComunas() {
    this.$axios
      .get("comunas/listar")
      .then((response) => {
        this.comunas = response.data;
        if (this.$store.state.user.adress.district) {
          this.formData.district = this.comunas.find(
            (district) =>
              district.label === this.$store.state.user.adress.district
          );
        } else if (this.$store.state.ticket.guest_adress_district) {
          this.formData.district = this.comunas.find(
            (district) =>
              district.label === this.$store.state.ticket.guest_adress_district
          );
        }
      })
      .catch((error) => {})
      .finally(() => {});
  }

  private mounted() {
    this.highlightMotive();
    this.streetDistrictData();
    this.getComunas();
    this.isDT();
    this.getMotivo();
    this.formatRut();

    /*
    if (this.date_request == true) {
      this.$store.state.ticket.motive = "1";
      this.formData.motive = "1";
    }
    */
  }

  private isDT() {
    return Number(process.env.VUE_APP_ID_COMUNA) == -1 ? false : true;
  }

  private aMotivoFunction() {
    return (this.$store.state.ticket.motivo = this.motivoData!.label);
  }

  private filterInput(event: any) {
    // Permite letras, espacios, teclas de navegación (flechas, Tab, etc.)
    // y la tecla de borrar/eliminar.
    const allowed = /^[a-zA-Z\sñÑáÁéÉíÍóÓúÚüÜ]$/;

    // El 'key' de eventos de teclado es más limitado y no incluye todos los códigos.
    // Usamos el 'keyCode' o 'key' para controlar.

    // Si la tecla es una letra, espacio o una tecla de control (como Backspace, Tab, Enter)
    if (
      allowed.test(event.key) ||
      event.ctrlKey ||
      event.metaKey ||
      event.keyCode === 8 ||
      event.keyCode === 9
    ) {
      return; // Permitir la entrada
    } else {
      // Si es un número o un carácter especial, prevenimos la acción por defecto (escribir el carácter)
      event.preventDefault();
    }
  }
}
